import { Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppValidators } from 'src/app/common/appValidators';
import { ViolationModel } from 'src/app/models/api/violations.model';
import { IChangeEventJustificationComponentOutput } from 'src/app/models/popups/outputs/changeEventJustificationComponentOutput.interface';

@Component({
  selector: 'app-change-event-justification-dialog',
  templateUrl: './change-event-justification-dialog.html',
  styleUrls: ['./change-event-justification-dialog.scss'],
})
export class ChangeEventJustificationDialogComponent {
  public justificationContentFormControl: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    AppValidators.noDollarSign,
    Validators.maxLength(250),
  ]);

  constructor(
    public dialogRef: MatDialogRef<ChangeEventJustificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public violationData: ViolationModel
  ) {
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeClick();
    });
  }

  public addJustification() {
    const output = {
      addJustification: true,
      content: this.justificationContentFormControl.value,
    } as IChangeEventJustificationComponentOutput;
    this._onClose(output);
  }
  public closeClick() {
    const output = {
      addJustification: false,
    } as IChangeEventJustificationComponentOutput;
    this._onClose(output);
  }
  private _onClose(output: IChangeEventJustificationComponentOutput): void {
    this.dialogRef.close(output);
  }
}
